<mat-card class="ic-fullscreen" [class.hidden]="!(show$ | async)">
    <mat-card-header>
        <mat-card-title>
            <h3>Cropper</h3>
            <mat-icon (click)="close()" class="close">close</mat-icon>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <image-cropper
            [imageFile]="fileToCrop$ | async"
            [maintainAspectRatio]="true"
            [autoCrop]="true"
            [aspectRatio]="(width$ | async) / (height$ | async)"
            [cropperMinWidth]="width$ | async"
            [cropperMinHeight]="height$ | async"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
            [roundCropper]="rounded$ | async"
        >
        </image-cropper>

        <img
            [src]="croppedImage"
            class="cropped-image"
            [width]="width$ | async"
            [height]="height$ | async"
            [class.rounded]="rounded$ | async"
        />
    </mat-card-content>
    <mat-card-actions>
        <button [id]="'button_image-cropper_CropImage'" mat-button color="primary" (click)="salvar()">
            {{ "IMAGE_CROPPER.ACTIONS.SAVE" | translate }}
        </button>
    </mat-card-actions>
</mat-card>
